
import SmsSearch from "../../../assets/filled/SmsSearch.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function SmsSearchIcon({ className, dataTestid = "SmsSearchIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <SmsSearch data-testid={dataTestid} className={classes} {...rest} />
  );
}
